export const parseId = (id: unknown): number | undefined => {
  let number = Number.NaN;
  if (typeof id === "string") {
    number = parseInt(id);
  }

  if (typeof id === "number") {
    number = id;
  }

  if (Number.isNaN(number)) {
    return undefined;
  }
  return number;
};
